/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default ({authGuard, guestGuard}) => [
  ...authGuard([
    {
      path: "",
      component: () => import("../layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          name: "dashboard",
          component: () => import("../views/Dashboard.vue"),
        },
        {
          path: '/underwriting-tools',
          name: 'underwriting_tools',
          component: () => import('@/views/pages/UnderwritingTools/UnderwritingTools.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'UnderwritingTools', active: true }
            ],
            pageTitle: 'UnderwritingTools',
            metaTitle: 'Underwriting Suite Tools',
          },
        },
        {
          path: '/underwriting-tools/downloading-all',
          name: 'underwriting_tools.download_all',
          component: () => import('@/views/pages/UnderwritingTools/DownloadAll.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'UnderwritingTools' },
              { title: 'Downloading', active: true }
            ],
            pageTitle: 'UnderwritingTools',
            metaTitle: 'Underwriting Suite Tools',
          },
        },
        {
          path: '/notify-a-claim',
          name: 'notify_a_claim',
          component: () => import('@/views/pages/NotifyAClaim/NotifyAClaim.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'NotifyAClaim', active: true }
            ],
            pageTitle: 'NotifyAClaim',
          },
        },
        {
          path: '/notify-a-claim/downloading-all',
          name: 'notify_a_claim.download_all',
          component: () => import('@/views/pages/NotifyAClaim/DownloadAll.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'NotifyAClaim' },
              { title: 'Downloading', active: true }
            ],
            pageTitle: 'NotifyAClaim',
          },
        },
        {
          path: '/renewal',
          name: 'renewal',
          component: () => import('@/views/pages/Renewals/Renewals.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Renewals', active: true }
            ],
            pageTitle: 'Renewals',
            metaTitle: 'Underwriting Suite Renewals',
          },
        },
        {
          path: '/work-in-progress',
          name: 'work_in_progress',
          component: () => import('@/views/pages/WorkInProgress/WorkInProgress.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'WorkInProgress', active: true }
            ],
            pageTitle: 'WorkInProgress',
            metaTitle: 'Underwriting Suite Work in Progress',
          },
        },
        {
          path: '/portfolio',
          name: 'portfolio',
          component: () => import('@/views/pages/Portfolio/Portfolio.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Portfolio', active: true }
            ],
            pageTitle: 'Portfolio',
            metaTitle: 'Underwriting Suite Portfolio',
          },
        },
        {
          path: '/coverholder/work-in-progress',
          name: 'coverholder_work_in_progress',
          component: () => import('@/views/pages/Coverholder/WorkInProgress/WorkInProgress.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'WorkInProgress', active: true }
            ],
            pageTitle: 'WorkInProgress',
            metaTitle: 'Underwriting Suite Work in Progress',
          },
        },
        {
          path: '/coverholder/portfolio',
          name: 'coverholder_portfolio',
          component: () => import('@/views/pages/Coverholder/Portfolio/Portfolio.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Portfolio', active: true }
            ],
            pageTitle: 'Portfolio',
            metaTitle: 'Underwriting Suite Portfolio',
          },
        },
        {
          path: '/contacts',
          name: 'contacts',
          component: () => import('@/views/pages/Contacts/Contacts.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Contacts', active: true }
            ],
            pageTitle: 'Contacts',
            metaTitle: 'Contacts',
          },
        },
        {
          path: '/upload',
          name: 'upload_firm_orders',
          component: () => import('@/views/pages/Upload/Upload.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Upload', active: true }
            ],
            pageTitle: 'Upload',
            metaTitle: 'Underwriting Suite Upload Firm Order',
          },
        },
        {
          path: '/upload/success/:clientReference',
          name: 'upload_firm_orders.success',
          component: () => import('@/views/pages/Upload/UploadSuccessful.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Upload', url: '/upload' },
              { title: 'Success', active: true }
            ],
            pageTitle: 'Upload',
            metaTitle: 'Underwriting Suite Upload Firm Order',
          },
        },
        {
          path: '/upload/error',
          name: 'upload_firm_orders.error',
          component: () => import('@/views/pages/Upload/UploadNotSuccessful.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Upload', url: '/upload' },
              { title: 'Error', active: true }
            ],
            pageTitle: 'Upload',
            metaTitle: 'Underwriting Suite Upload Firm Order',
          },
        },
      ],
    },
  ]),
  // Guest routes.
  ...guestGuard([
    {path: "*", redirect: {name: "login"}},
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Callback.vue"),
    },
    {
      path: "/callback",
      name: "auth-callback",
      component: () => import("@/views/Callback.vue"),
    },
  ])
]
